.largeProfileImage {
  flex: 0 0 100px;
  height: 100px;
  user-select: none;
  width: 100px;
}

.largeProfileImageArea {
  align-items: center;
  border-radius: 100%;
  color: white;
  display: flex;
  font-size: 64px;
  height: 100px;
  justify-content: center;
  object-fit: cover;
  object-position: center;
  pointer-events: none;
  width: 100px;
}

/** only for non image avatars */
span.largeProfileImageArea {
  --local-avatar-color: #bcbac9;
  background-color: var(--local-avatar-color);
}
@supports (text-wrap: wrap) {
  span.largeProfileImageArea {
    background: linear-gradient(var(--avatarGradientAngle), var(--local-avatar-color), color-mix(in srgb, var(--local-avatar-color) var(--avatarGradientMixFactor), white));
  }
}

.largeProfileImageDefaultIcon {
  background-color: white;
}